import { css } from '@emotion/react';

export const carouselStyles = {
    container: css({
        display: 'flex',
        gap: '8px',
        overflowX: 'auto',
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch',
        padding: '12px 0',
        marginBottom: '16px',
        minHeight: '152px',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        scrollbarWidth: 'none',
    }),
    imageWrapper: css({
        flex: '0 0 auto',
        width: '128px',
        height: '128px',
        borderRadius: '12px',
        overflow: 'hidden',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        cursor: 'pointer',
        transition: 'transform 0.2s',
        '&:hover': {
            transform: 'scale(1.05)',
        },
    }),
    image: css({
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    }),
    previewOverlay: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        outline: 'none',
    }),
    previewContent: css({
        position: 'relative',
        maxWidth: '90vw',
        maxHeight: '90vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    previewImage: css({
        maxWidth: '100%',
        maxHeight: '90vh',
        objectFit: 'contain',
        borderRadius: '8px',
    }),
};
